<!-- components/bando-card/bando-card.component.html -->
<div class="bando-card">
    <div class="bando-header">
      <h2 class="bando-title">{{ bando.title }}</h2>
      <div class="bando-actions">
        <span [class]="'status-badge ' + getStatusClass(bando.status)">
          {{ getStatusLabel(bando.status) }}
        </span>
        <button 
          class="favorite-button"
          (click)="onFavoriteClick()"
          [attr.aria-label]="'Toggle favorite for ' + bando.title"
        >
          <i class="far fa-heart"></i>
        </button>
      </div>
    </div>
  
    <div class="bando-organization" [innerHTML]="bando.section_program"></div>
  
    <div class="bando-tags">
      <span class="tag new-tag" *ngIf="bando.is_recent">New</span>
      <span 
        class="tag sector-tag" 
        *ngFor="let sector of getVisibleSectors()"
        [title]="sector.title"
      >
        {{ sector.title }}
      </span>
      <span class="more-tags" *ngIf="getHiddenSectorsCount() > 0">
        +{{ getHiddenSectorsCount() }}
      </span>
    </div>
  
    <div class="bando-beneficiaries">
      <span 
        class="beneficiary-tag" 
        *ngFor="let beneficiary of bando.beneficiaries"
        [title]="beneficiary.title"
      >
        {{ beneficiary.title }}
      </span>
    </div>
  
    <div class="bando-deadline">
      <i class="far fa-calendar"></i>
      {{ formatDeadlineMessage(bando.deadline_days_left, bando.deadline_label) }}
    </div>
  
    <div class="bando-budget" *ngIf="bando.budget > 0">
      Budget: {{ bando.budget | currency:'EUR':'symbol':'1.0-0' }}
    </div>
  </div>